import normalize from 'json-api-normalizer';

export default class Video {
	static from (jsonapi) {
		let key = 'videos'
		let normalizedJSONapi = normalize(jsonapi);
		if (!(Object.keys(normalizedJSONapi).includes(key))) return null;

		let keys = Object.keys(normalizedJSONapi[key]);
		if (keys.length > 0 && Array.isArray(jsonapi.data)) {
			let retVal = {};
			keys.forEach( function ( id ) {
				retVal[id] = Video.make(normalizedJSONapi[key][id], normalizedJSONapi);
			});
			return retVal;
		} else return Video.make(normalizedJSONapi[key][keys[0]], normalizedJSONapi);
	}

	static make(jsonapi, normalizedJSONapi) {
		const { id, attributes } = jsonapi;

		let relationships = {}
		return new Video ( Object.assign({id: id}, attributes, relationships) );
	}

	constructor ({ id, title, description, startsAt, endsAt, language , vtype, url, mimeType, filesize, filename, position, isActive }) {
		this.id             = id ? id : -1;
        this.title      = title ? title : null;
		this.description      = description ? description : null;
        // this.starts_at = startsAt ? startsAt : null;
		// this.ends_at = endsAt ? endsAt : null;
		this.language        = language ? language : 'en';
        this.vtype        = vtype ? vtype : 'global';
		this.url            = url ? url.replace(/##HIPPO_URL##/g, (process.env.VUE_APP_API_URL + "/video")) : '';
		// this.mime_type      = mimeType ? mimeType : '';
		// this.filesize       = filesize ? filesize : 0;
		this.filename       = filename ? filename : '';
		this.position			= (position !=null) ? position : null;
		// this.is_active = isActive ? isActive : null;
	}

}
